import { DraftDesignConfiguration } from '@/types';
import { getPersistedDesignIds } from '@/utils/upload/persistedDesigns';
import { isDraftDesignConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { isUploadedDesign } from '@/model/design/isUploadedDesign';
import { StoreState } from '@/redux/types';
import { selectConfigurations } from './selectConfigurations';

export const getAllUserDesigns = (state: StoreState) => {
  const upload = getPersistedDesignIds();
  const configurationsWithUserDesign = selectConfigurations(state).filter(
    (configuration) =>
      isDraftDesignConfiguration(configuration) && isUploadedDesign(configuration.design)
  ) as DraftDesignConfiguration[];
  const configurationsWithFilteredUserDesign = configurationsWithUserDesign.filter(
    (configuration) => configuration.filter
  );
  const mapDesignId = (configurations: DraftDesignConfiguration[]) =>
    configurations.map(({ design: { id } }) => id);

  const draftUserDesigns = mapDesignId(configurationsWithUserDesign);

  return {
    all: [...new Set(upload.concat(draftUserDesigns))],
    draft: draftUserDesigns,
    filter: mapDesignId(configurationsWithFilteredUserDesign),
  };
};
